export default __webpack_public_path__ + "static/media/FundacionChile.6eff1487.svg";